import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "SH_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#SH_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#2E42A5"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "SH_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#SH_svg__b)" }, /* @__PURE__ */ e.createElement("path", { fill: "#2B409A", d: "M0 0h18v14H0z" }), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "SH_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 18,
      height: 14
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h18v14H0z" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#SH_svg__c)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M-2.006 13l3.961 1.737L18.088 1.89l2.09-2.582-4.236-.58-6.58 5.537-5.297 3.73L-2.005 13z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M-1.463 14.216l2.018 1.009L19.428-.933h-2.833l-18.058 15.15z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M20.004 13l-3.961 1.737L-.09 1.89-2.18-.693l4.236-.58 6.58 5.537 5.297 3.73L20.003 13z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M19.87 13.874l-2.019 1.008-8.036-6.918-2.383-.773L-2.38-.684H.453l9.807 7.688 2.605.927 7.004 5.943z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "SH_svg__d",
      maskUnits: "userSpaceOnUse",
      x: -2,
      y: -2,
      width: 22,
      height: 18,
      fill: "#000"
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M-2-2h22v18H-2z" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.985 0h-2v6H0v2h7.985v6h2V8H18V6H9.985V0z"
      }
    )
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.985 0h-2v6H0v2h7.985v6h2V8H18V6H9.985V0z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.985 0v-1.5h-1.5V0h1.5zm2 0h1.5v-1.5h-1.5V0zm-2 6v1.5h1.5V6h-1.5zM0 6V4.5h-1.5V6H0zm0 2h-1.5v1.5H0V8zm7.985 0h1.5V6.5h-1.5V8zm0 6h-1.5v1.5h1.5V14zm2 0v1.5h1.5V14h-1.5zm0-6V6.5h-1.5V8h1.5zM18 8v1.5h1.5V8H18zm0-2h1.5V4.5H18V6zM9.985 6h-1.5v1.5h1.5V6zm-2-4.5h2v-3h-2v3zm1.5 4.5V0h-3v6h3zM0 7.5h7.985v-3H0v3zm1.5.5V6h-3v2h3zm6.485-1.5H0v3h7.985v-3zm1.5 7.5V8h-3v6h3zm.5-1.5h-2v3h2v-3zM8.485 8v6h3V8h-3zM18 6.5H9.985v3H18v-3zM16.5 6v2h3V6h-3zM9.985 7.5H18v-3H9.985v3zM8.485 0v6h3V0h-3z",
      fill: "#F7FCFF",
      mask: "url(#SH_svg__d)"
    }
  )), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22.039 9.782h-.25v.25c0 .433-.002.858-.004 1.272-.005.987-.009 1.917.014 2.77.033 1.212.122 2.292.351 3.193.23.902.605 1.648 1.227 2.165.625.519 1.466.782 2.574.782 1.12 0 1.985-.328 2.634-.92.645-.586 1.055-1.411 1.311-2.37.51-1.907.436-4.43.294-6.906l-.013-.236h-8.138z",
      fill: "#B7E1FF",
      stroke: "#F7FCFF",
      strokeWidth: 0.5
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "SH_svg__e",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 21,
      y: 9,
      width: 10,
      height: 12
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M22.039 9.782h-.25v.25c0 .433-.002.858-.004 1.272-.005.987-.009 1.917.014 2.77.033 1.212.122 2.292.351 3.193.23.902.605 1.648 1.227 2.165.625.519 1.466.782 2.574.782 1.12 0 1.985-.328 2.634-.92.645-.586 1.055-1.411 1.311-2.37.51-1.907.436-4.43.294-6.906l-.013-.236h-8.138z",
        fill: "#fff",
        stroke: "#fff",
        strokeWidth: 0.5
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#SH_svg__e)" }, /* @__PURE__ */ e.createElement("path", { fill: "#2E42A5", d: "M24 18h6v2h-6z" }), /* @__PURE__ */ e.createElement("g", { filter: "url(#SH_svg__filter0_d_4799_266022)" }, /* @__PURE__ */ e.createElement("path", { fill: "#FDFF00", d: "M20 8h12v6H20z" })), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M25.18 10.877a1.416 1.416 0 00-.052-.275l.473 1.468a2.025 2.025 0 00-.144-.128c-.03-.024-.053-.044-.078-.066-.1-.091-.15-.159-.158-.287l-.015-.292a8.746 8.746 0 00-.027-.42zm-.375 2.582s0 0 0 0l.089.07h0l-.089-.07z",
      fill: "#F7FCFF",
      stroke: "#272727"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M24.826 14.044h.2v3.955h-.2v-3.955z", fill: "#FDFF00" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24.1 16.813h1.782s.018.514-.253.419c-.27-.095.027.095-.385 0-.411-.095-.774.299-.866.102-.093-.197-.451.056-.365-.233l.087-.288z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement("path", { fill: "#212123", d: "M24.133 16.764h1.733v.2h-1.733z" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24.347 16.065h1.427s.013.412-.203.336c-.217-.076.021.076-.308 0-.33-.076-.62.239-.693.081-.074-.157-.36.045-.292-.186l.07-.23z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement("path", { fill: "#212123", d: "M24.373 16.026h1.387v.2h-1.387z" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24.086 15.245h1.546s.014.412-.22.336c-.235-.077.023.076-.334 0-.356-.077-.67.239-.75.08-.08-.157-.391.046-.316-.185l.074-.23z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement("path", { fill: "#212123", d: "M24.115 15.206h1.502v.2h-1.502z" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24.213 14.557h1.426s.014.514-.203.419c-.216-.095.022.095-.308 0s-.62.299-.693.102c-.074-.197-.36.056-.291-.233l.069-.288z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement("path", { fill: "#212123", d: "M24.238 14.508h1.387v.2h-1.387z" }), /* @__PURE__ */ e.createElement("path", { d: "M26.742 14.544h.2v3.955h-.2v-3.955z", fill: "#FDFF00" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M26.1 16.976h1.782s.018.411-.253.335c-.27-.076.027.076-.385 0-.411-.076-.774.239-.866.081-.093-.157-.451.045-.365-.186l.087-.23z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement("path", { fill: "#212123", d: "M26.133 16.936h1.733v.2h-1.733z" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M26.363 16.23h1.401s.014.31-.199.252c-.213-.057.021.057-.302 0-.324-.057-.609.18-.681.061-.073-.118-.354.034-.286-.14l.067-.172z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement("path", { fill: "#212123", d: "M26.389 16.2h1.362v.2h-1.362z" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M26.085 15.41h1.529s.014.309-.218.252c-.232-.057.024.057-.33 0-.352-.057-.663.179-.742.06-.08-.117-.387.034-.313-.139l.075-.173z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement("path", { fill: "#212123", d: "M26.113 15.38h1.486v.2h-1.486z" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M26.22 14.72h1.402s.013.411-.2.335c-.212-.076.022.076-.302 0-.323-.076-.608.24-.68.082-.073-.158-.355.044-.287-.187l.068-.23z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement("path", { fill: "#212123", d: "M26.246 14.681h1.362v.2h-1.362z" }), /* @__PURE__ */ e.createElement("path", { d: "M29.49 14.059h.2v5.258h-.2V14.06z", fill: "#FDFF00" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M28.674 17.253h2.269s.022.412-.323.335c-.344-.076.035.076-.49 0-.523-.076-.985.24-1.103.082-.117-.158-.573.044-.463-.186l.11-.231z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement("path", { fill: "#212123", d: "M28.715 17.214h2.206v.2h-2.206z" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M29.01 16.255h1.783s.017.309-.254.251c-.27-.057.027.058-.384 0-.412-.057-.775.18-.867.061-.093-.118-.45.034-.364-.139l.086-.173z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement("path", { fill: "#212123", d: "M29.043 16.23h1.733v.2h-1.733z" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M28.828 14.935h1.783s.017.411-.253.335c-.271-.076.027.076-.385 0-.412-.076-.775.239-.867.081-.092-.157-.45.045-.364-.186l.086-.23z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement("path", { fill: "#212123", d: "M28.861 14.896h1.733v.2h-1.733z" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24.186 17.686s.925.503 2.337.417c1.41-.087 1.31.185 1.675-.202.367-.388.399-.301.855-.505.457-.203.522-.395.758-.395.235 0 2.742-.1 2.742-.1s-.23.205-.23.495c0 .29.153.32 0 .583-.152.263-.325.615-.547.717-.222.102-3.218.167-3.982.167-.764 0-2.333.085-2.514 0-.18-.085-1.095-1.177-1.095-1.177z",
      fill: "#272727"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.117 15.686l.893-.823s.04 0 .205.412c.166.411.174.974.347.833.173-.14.438-.01.55-.422.112-.411.105-.944.247-.678.143.267.058-.123.285.489.227.611.317-.263.442.611s.23 1.176.23 1.38c0 .203 1.138.809.701 1.226-.436.417-.312.22-.7.483-.389.262-.787.11-.231.316.556.206.476.58.476.855s-.034.399-.476.337c-.442-.062-.98.158-1.086.158-.108 0-1.403-.264-1.403-.807s-.48-4.37-.48-4.37z",
      fill: "#CE6201"
    }
  )))),
  /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
    "filter",
    {
      id: "SH_svg__filter0_d_4799_266022",
      x: 20,
      y: 8,
      width: 12,
      height: 7,
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB"
    },
    /* @__PURE__ */ e.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
    /* @__PURE__ */ e.createElement(
      "feColorMatrix",
      {
        in: "SourceAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }
    ),
    /* @__PURE__ */ e.createElement("feOffset", { dy: 1 }),
    /* @__PURE__ */ e.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" }),
    /* @__PURE__ */ e.createElement(
      "feBlend",
      {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_4799_266022"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "feBlend",
      {
        in: "SourceGraphic",
        in2: "effect1_dropShadow_4799_266022",
        result: "shape"
      }
    )
  ))
), h = t;
export {
  h as default
};
